export var ProductType;
(function (ProductType) {
    ProductType["DIGITAL"] = "digital";
    ProductType["PHYSICAL"] = "physical";
})(ProductType || (ProductType = {}));
export var ProductInventoryStatus;
(function (ProductInventoryStatus) {
    ProductInventoryStatus["OUT_OF_STOCK"] = "out_of_stock";
    ProductInventoryStatus["IN_STOCK"] = "in_stock";
})(ProductInventoryStatus || (ProductInventoryStatus = {}));
export var MediaFrameMediaType;
(function (MediaFrameMediaType) {
    MediaFrameMediaType["SECURE_PICTURE"] = "secure_picture";
    MediaFrameMediaType["SECURE_VIDEO"] = "secure_video";
    MediaFrameMediaType["SECURE_DOCUMENT"] = "secure_document";
    MediaFrameMediaType["SECURE_MUSIC"] = "secure_music";
    MediaFrameMediaType["SECURE_ARCHIVE"] = "secure_archive";
})(MediaFrameMediaType || (MediaFrameMediaType = {}));
//# sourceMappingURL=product.js.map